import { GlobalStoreState } from "../global-store";
import { PreferencesStoreState } from "../preferences-store";

export const LS_VERSION = 1;

export enum LS_Store_Name {
    Global = "Remo-Global-Store",
    Preferences = "Remo-Preferences-Store",
}

export interface LSStoreType<T> {
    version: number;
    state: T;
}

export type PreferencesStoreProperties = {
    [K in keyof PreferencesStoreState as PreferencesStoreState[K] extends Function
        ? never
        : K]: PreferencesStoreState[K];
};

export type GlobalStoreProperties = Pick<
    GlobalStoreState,
    "serverRegionConfig" | "userInfo" | "currentAccount" | "accountHistory" | "lastLoginCheck"
>;

export type StoreProperties =
    | LSStoreType<GlobalStoreProperties>
    | LSStoreType<PreferencesStoreProperties>;

export const getLSStore = <T extends StoreProperties>(name: LS_Store_Name | string): T | null => {
    const str = localStorage.getItem(name);
    if (!str) {
        return null;
    }
    try {
        const { version, state } = JSON.parse(str);
        if (version !== LS_VERSION) {
            localStorage.removeItem(name);
            return null;
        }
        return { state, version } as T;
    } catch (error) {
        console.error(`Failed to parse localStorage item ${name}`, error);
        return null;
    }
};

export const setLSStore = <T extends StoreProperties>(
    name: LS_Store_Name | string,
    value: T,
): void => {
    if (LS_VERSION !== value.version) {
        return;
    }
    localStorage.setItem(name, JSON.stringify([LS_VERSION, value.state]));
};

export const removeLSStore = (name: LS_Store_Name | string): void => {
    localStorage.removeItem(name);
};
